(function() {
  'use strict';

  angular.module('ringbaPortal').directive('toasterPlayer', toasterPlayer);

  function toasterPlayer() {
    const directive = {
      restrict: 'EA',
      scope: true,
      controller: ToasterPlayerController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/components/audio-player/toaster-player.view.html'
    };
    return directive;
  }

  function ToasterPlayerController(
    $interval,
    $scope,
    $timeout,
    ngAudio
  ) {
    'ngInject';

    const vm = this;
    let forwardBackwardInterval;

    vm.$onInit = onInit;
    vm.setPlaybackRate = setPlaybackRate;
    vm.fastForwardOrBackward = fastForwardOrBackward;
    vm.resumePlay = resumePlay;
    vm.pause = pause;

    function onInit() {
      vm.inboundNumber = $scope.directiveData.inboundNumber;
      vm.recordingUrl = $scope.directiveData.url;

      vm.recording = ngAudio.load($scope.directiveData.url);
      vm.recording.play();
    }

    function setPlaybackRate() {
      if (!vm.recording.paused) {
        switch (vm.recording.playbackRate) {
        case undefined:
        case 1:
          vm.recording.playbackRate = 1.2;
          break;
        case 1.2:
          vm.recording.playbackRate = 1.5;
          break;
        case 1.5:
          vm.recording.playbackRate = 2;
          break;
        case 2:
          vm.recording.playbackRate = 3;
          break;
        case 3:
          vm.recording.playbackRate = 0.5;
          break;
        case 0.5:
          vm.recording.playbackRate = 1;
          break;
        default:
          break;
        }
      }
    }

    function fastForwardOrBackward(direction, click) {
      if (!vm.recording.paused) {
        if (click) {
          $timeout(function () {
            vm.recording.currentTime = vm.recording.currentTime + (direction === 'forward' ? 10 : -10);
            vm.recording.play();
          }, 200);
        } else {
          vm.recording.pause();
          forwardBackwardInterval = $interval(function () {
            vm.recording.currentTime = vm.recording.currentTime + (direction === 'forward' ? 10 : -10);
          }, 200);
        }
      }
    }

    function resumePlay() {
      if (forwardBackwardInterval) {
        $interval.cancel(forwardBackwardInterval);
        forwardBackwardInterval = null;
        vm.recording.play();
      }
    }

    function pause() {
      if (vm.recording.currentTime > 0 && !vm.recording.paused) {
        vm.recording.pause();
      }
    }

    $scope.$on('$destroy', function () {
      vm.recording.stop();
      vm.recording.destroy();
      vm.recording.audio.remove();
    });


  }
})();
